module.exports = __webpack_public_path__ + "static/media/Ribossomo.95d17bda.glb";